/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { provideLocalizationService as a, registerForLocalization as n } from "@progress/kendo-react-intl";
import { clear as r, messages as i } from "../messages/index.mjs";
import { IconWrap as s } from "@progress/kendo-react-common";
import { xIcon as c } from "@progress/kendo-svg-icons";
class l extends e.Component {
  constructor() {
    super(...arguments), this.handelClick = (t) => {
      t.stopPropagation();
      const { onClick: o } = this.props;
      o && o.call(void 0, t);
    };
  }
  render() {
    const t = a(this).toLanguageString(r, i[r]);
    return /* @__PURE__ */ e.createElement(
      "span",
      {
        className: "k-clear-value",
        role: "button",
        onClick: this.handelClick,
        tabIndex: this.props.tabindex || -1,
        title: t,
        key: "clearbutton"
      },
      /* @__PURE__ */ e.createElement(s, { name: "x", icon: c })
    );
  }
}
n(l);
export {
  l as default
};
